import { Download, MonitorSmartphone } from "lucide-react";
import { toast } from "sonner";

import { Button, type ButtonProps } from "@/components/ui/button";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

interface InstallAppButtonProps extends Omit<ButtonProps, "onClick"> {
  label?: string;
  compactLabel?: string;
}

export function InstallAppButton({
  className,
  label = "Install app",
  compactLabel = "Install",
  size = "default",
  variant = "secondary",
  ...props
}: InstallAppButtonProps) {
  const { canInstall, isInstalled, promptInstall } = useInstallPrompt();

  if (isInstalled || !canInstall) {
    return null;
  }

  return (
    <Button
      className={className}
      size={size}
      variant={variant}
      onClick={async () => {
        const result = await promptInstall();
        if (result.outcome === "accepted") {
          toast.success("seaDrive is being installed on this device.");
          return;
        }
        if (result.outcome === "dismissed") {
          toast.message("Installation dismissed. You can install seaDrive later anytime.");
          return;
        }
        toast.message("Install is available from your browser menu once the page is ready.");
      }}
      {...props}
    >
      {size === "icon" ? <Download /> : <MonitorSmartphone className="h-4 w-4" />}
      {size === "icon" ? null : (
        <>
          <span className="sm:hidden">{compactLabel}</span>
          <span className="hidden sm:inline">{label}</span>
        </>
      )}
    </Button>
  );
}
